import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[soloNumeros]',
})
export class SoloNumerosDirective {
  private readonly regex: RegExp = /^[0-9]+$/g;
  private readonly specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
    'Enter',
  ];

  constructor(private el: ElementRef<HTMLInputElement>) {}

  private check(value: string, event: Event) {
    if (typeof value !== 'string') return;

    const current: string = this.el.nativeElement.value;
    const position: number | null = this.el.nativeElement.selectionStart;
    if (position === null) return;

    const next: string = [
      current.slice(0, position),
      value === '.' ? ',' : value,
      current.slice(position),
    ].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (
      this.specialKeys.indexOf(event.key) !== -1 ||
      event.ctrlKey ||
      event.metaKey
    ) {
      return;
    }
    this.check(event.key, event);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const paste = event.clipboardData?.getData('Text');
    if (!paste) return;

    this.check(paste, event);
  }

  @HostListener('beforeinput', ['$event']) onBeforeInput(e: InputEvent): any {
    if (isNaN(Number(e.data))) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}
